import qs from 'qs';
import { network } from 'services/network';

export const getIntegratedScheduleDetails = (params: { fileMetaDataId: number }) => {
    const querystring = qs.stringify(
        { fileMetaDataId: params.fileMetaDataId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getIntegratedScheduleDetails${querystring}`;
    return network.get(url).then((response) => response.data);
};
